/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Chip_Create_ChannelInputs */

const tr_landing_community_chip_create_channel = /** @type {(inputs: Landing_Community_Chip_Create_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanal oluşturma`)
};

const en_landing_community_chip_create_channel = /** @type {(inputs: Landing_Community_Chip_Create_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create channels`)
};

const de_landing_community_chip_create_channel = /** @type {(inputs: Landing_Community_Chip_Create_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanäle erstellen`)
};

const ru_landing_community_chip_create_channel = /** @type {(inputs: Landing_Community_Chip_Create_ChannelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создание каналов`)
};

/**
* | output |
* | --- |
* | "Create channels" |
*
* @param {Landing_Community_Chip_Create_ChannelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_chip_create_channel = /** @type {((inputs?: Landing_Community_Chip_Create_ChannelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Chip_Create_ChannelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_chip_create_channel(inputs)
	if (locale === "de") return de_landing_community_chip_create_channel(inputs)
	if (locale === "ru") return ru_landing_community_chip_create_channel(inputs)
	return tr_landing_community_chip_create_channel(inputs)
});